import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './shared-ui/sidebar/sidebar.component';
import { NavbarComponent } from './shared-ui/navbar/navbar.component';
import { CalendarIconComponent } from './shared-ui/icon/svg-icon/svg-icon.component';
import { FeatureFlagDirective } from './shared-ui/directives/feature-flag.directive';

@NgModule({
  declarations: [
    SidebarComponent,
    NavbarComponent,
    CalendarIconComponent,
    FeatureFlagDirective,
  ],
  imports: [CommonModule, RouterModule],
  exports: [
    SidebarComponent,
    NavbarComponent,
    CalendarIconComponent,
    FeatureFlagDirective,
  ],
})
export class GlobalModule {}